import React, {useContext} from 'react';
import './Offline.less';
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import WifiIcon from 'new-images/wifi.svg';
import {Message} from 'compositions/message/Message';
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const OFFLINE_POPUP = 'OFFLINE_POPUP';

export const Offline = ({onOverlayClick}) => {
	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		onOverlayClick={onOverlayClick}
	>
		<div className="offline">
			<div className="offline__message">
				<Message
					icon={WifiIcon}
					title={getSafeTranslation('OfflinePopup.title', translations)}
					description={getSafeTranslation('OfflinePopup.description', translations)}
				/>
			</div>
		</div>
	</DrawerPopup>
}
